module.exports = __webpack_public_path__ + "static/media/favicon_blue.eb6d1121.ico";